import { FC, useEffect, Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { FormContainer } from 'app/hooks/useGlobalForm';
import ThankYouMobile from './ThankYouMobile';
import ThankYouDesktop from './ThankYouDesktop';
import { isMobile } from 'utils/isMobile';
import { gaCartFormatter } from 'utils/GAnalytics/formatters';
import { OrderCheckoutOutputInterface } from 'ks-common';
import cloneDeep from 'lodash/cloneDeep';
import priceMask from 'utils/priceMask';

const ThankYou: FC = () => {
  const { products, setThankYouProducts, clearForm, isEdit } =
    FormContainer.useContainer();
  const location = useLocation();
  const state = location?.state as OrderCheckoutOutputInterface;
  const orderId = state?.OrderId;
  const orderQuote = state?.OrderQuoteCalculated;

  useEffect(() => {
    setThankYouProducts(cloneDeep(products));
    if (!isEdit) {
      const gaData = gaCartFormatter(state.OrderQuoteCalculated);
      const purchaseData = {
        transaction_id: orderId,
        tax: priceMask(orderQuote.TaxValue * 100, true),
        ...gaData,
      };

      const gaEmail = state?.Customer?.Email;
      let gaCc = (state?.Customer?.CountryCodeCellPhone || '')
        .toString()
        .trim();
      if (gaCc && !gaCc.startsWith('+')) gaCc = `+${gaCc}`;
      const gaPhone = state?.Customer?.CellPhone
        ? `${gaCc}${state.Customer.CellPhone}`
        : undefined;

      ReactGA.gtag('set', 'user_data', {
        email: gaEmail,
        phone_number: gaPhone,
      });

      !isEdit && ReactGA.event('purchase', purchaseData);

      clearForm();
    }
  }, []);

  return (
    <Fragment>{isMobile ? <ThankYouMobile /> : <ThankYouDesktop />}</Fragment>
  );
};

export default ThankYou;
